import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { OnoffType } from '@/api/enum/common.enum';
import { User21Filter } from '@/api/DTO/user/userList.interface';

export default function Series21ProgressSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<User21Filter>();
	const statusList = [
		{ id: OnoffType.off, name: t('meditation.off') },
		{ id: OnoffType.on, name: t('meditation.on') },
	];

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='statuses'
					label={t('meditation.status')}
					options={statusList}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
		</Grid>
	);
}
